import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/autoplay';

import { Autoplay } from 'swiper/modules';

const Home = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [team, setTeam] = useState([]);
  const [teamLoading, setTeamLoading] = useState(true);
  const [teamError, setTeamError] = useState('');
  const [insurances, setInsurances] = useState([]);
  const [insurancesLoading, setInsurancesLoading] = useState(true);
  const [packages, setPackages] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get('https://hasanhaji.com/api/services');
        setServices(res.data.data.services);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching services:', err);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const res = await axios.get('https://hasanhaji.com/api/team');
        setTeam(res.data.data.teamMembers);
        setTeamLoading(false);
      } catch (err) {
        console.error('Error fetching team:', err);
        setTeamError('حدث خطأ أثناء تحميل الفريق الطبي. الرجاء المحاولة مرة أخرى.');
        setTeamLoading(false);
      }
    };

    fetchTeam();
  }, []);

  useEffect(() => {
    const fetchInsurances = async () => {
      try {
        const res = await axios.get('https://hasanhaji.com/api/insurance');
        setInsurances(res.data);
        setInsurancesLoading(false);
      } catch (err) {
        console.error('Error fetching insurances:', err);
        setInsurancesLoading(false);
      }
    };

    fetchInsurances();
  }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const res = await axios.get('https://hasanhaji.com/api/packages');
        setPackages(res.data);
        setPackagesLoading(false);
      } catch (err) {
        console.error('Error fetching packages:', err);
        setPackagesLoading(false);
      }
    };

    fetchPackages();
  }, []);

  return (
    <div className="landing-page-only">
      { }
      <section id="home" className="hero-section mobile-page">
        <div className="container hero-grid">
          <div className="hero-content">
            <p className="hero-eyebrow">{t('home.hero.eyebrow')}</p>
            <h1>
              <span>{t('home.hero.title')}</span>
              {t('home.hero.titleSuffix')}
            </h1>
            {t('home.hero.description')
              .split('\n\n')
              .map((p, i) => (
                <p className="hero-lead" key={i}>
                  {p}
                </p>
              ))}

            <div className="hero-cta">
              <Link to="/services" className="btn hero-btn">
                {t('home.hero.exploreServices')}
              </Link>
              <Link to="/analyses" className="btn btn-outline-light hero-btn-alt">
                {t('home.hero.myTests')}
              </Link>
            </div>
            <div className="hero-stats">

              <div>
                <strong>24/7</strong>
                <span>{t('home.hero.support247')}</span>
              </div>
              <div>
                <strong>30+</strong>
                <span>{t('home.hero.yearsExperience')}</span>
              </div>
            </div>
          </div>

          <div className="hero-image">
            <span className="hero-image-bg"></span>
            <img src="/images/doctor-header.png" alt="الدكتور حسن حاجي" />


          </div>
        </div>
      </section>

      { }
      <section id="services" className="section services-section mobile-page">
        <div className="services-bg-overlay"></div>
        <div className="container position-relative">
          <h2 className="section-title">{t('home.services.title')}</h2>
          <div className="row" style={{ '--bs-gutter-y': '1.5rem' }}>
            {loading ? (
              <div className="col-12 text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">{t('home.services.loading')}</span>
                </div>
              </div>
            ) : (
              services.map((service) => (
                <div className="col-md-4" key={service.id}>
                  <div className="service-card" data-service={service.icon}>

                    <div className="service-icon">
                      <img
  src={service.icon}
  alt={i18n.language === 'ar' ? service.name : (service.nameEn || service.name)}
  style={{ height: '50px', objectFit: 'contain' }}
/>
                    </div>
                    <h3>{i18n.language === 'ar' ? service.name : (service.nameEn || service.name)}</h3>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      { }
      <section id="packages" className="section packages-section mobile-page">
        <div className="container">
          <h2 className="section-title">{t('home.packages.title')}</h2>
          <p className="section-subtitle text-center mb-5">
            {t('home.packages.subtitle')}
          </p>

          {packagesLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t('home.packages.loading')}</span>
              </div>
            </div>
          ) : packages.length === 0 ? (
            <p className="text-center text-muted">{t('home.packages.noPackages')}</p>
          ) : (
            <div className="row g-4">
              {packages.slice(0, 3).map((pkg) => (
                <div key={pkg.id} className="col-lg-4 col-md-6">
                  <div className="package-card">
                    <div className="package-header">
                      <h3 className="package-name">
                        {i18n.language === 'ar' ? pkg.nameAr : pkg.nameEn}
                      </h3>
                      <div className="package-price">
                        <span className="price-amount">{pkg.price}</span>
                        <span className="price-currency">{t('packages.currency')}</span>
                      </div>
                    </div>

                    {(() => {
                      const desc = i18n.language === 'ar' ? pkg.descriptionAr : pkg.descriptionEn;
                      return desc && desc.trim() !== "";
                    })() && (
                        <div className="package-description">
                          <p>{i18n.language === 'ar' ? pkg.descriptionAr : pkg.descriptionEn}</p>
                        </div>
                      )}


                    <div className="package-features">
                      <h4 className="features-title">{t('packages.includes')}</h4>
                      <ul className="features-list">
                        {pkg.features && pkg.features.slice(0, 5).map((feature, index) => (
                          <li key={index} className="feature-item">
                            <i className="fas fa-check-circle"></i>
                            <span>{i18n.language === 'ar' ? feature.nameAr : feature.nameEn}</span>
                            {feature.count && <span className="feature-count">({feature.count})</span>}
                          </li>
                        ))}
                        {pkg.features && pkg.features.length > 5 && (
                          <li className="feature-item text-muted">
                            <span>+ {pkg.features.length - 5} {t('home.packages.more')}</span>
                          </li>
                        )}
                      </ul>
                    </div>

                    <div className="package-footer">
                      <button className="btn-package">
                        {t('packages.bookNow')}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="text-center mt-5">
            <Link to="/packages" className="btn btn-outline-primary rounded-pill px-4 py-2">
              {t('home.packages.viewAll')}
            </Link>
          </div>
        </div>
      </section>

      { }
      <section id="doctors" className="section doctors-section mobile-page">
        <div className="doctors-bg-overlay"></div>
        <div className="container position-relative">
          <h2 className="section-title">{t('home.doctors.title')}</h2>
          <p className="section-subtitle text-center mb-5">
            {t('home.doctors.subtitle')}
          </p>
          {teamLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t('home.doctors.loading')}</span>
              </div>
            </div>
          ) : teamError ? (
            <div className="alert alert-danger text-center" role="alert">
              {t('home.doctors.error')}
            </div>
          ) : team.length === 0 ? (
            <p className="text-center text-muted">
              {t('home.doctors.noTeam')}
            </p>
          ) : (
            <div className="row justify-content-center">
              {team.filter(member => member.jobTitle !== 'Nurse').map((member) => (
                <div className="col-lg-4 col-md-6 mb-4" key={member.id}>
                  <div className="doctor-card">
                    <div className="doctor-image">
                      <img
                        src={member.image || '/images/doctors/dr-hassan.jpg'}
                        alt={member.nameAr || member.name}
                      />
                    </div>
                    <div className="doctor-info">
                      <h3>{i18n.language === 'ar' ? (member.nameAr || member.name) : (member.nameEn || member.name)}</h3>
                      <p className="specialty">
                        {i18n.language === 'ar'
                          ? (member.specialtyAr || member.specialty)
                          : (member.specialtyEn || member.specialty)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>



      { }
      <section id="insurance" className="section insurance-section mobile-page">
        <div className="container">
          <h2 className="section-title">{t('home.insurance.title')}</h2>
          <div className="row">
            <div className="col-12">
              {insurancesLoading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('home.insurance.loading')}</span>
                  </div>
                </div>
              ) : insurances.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-shield-alt fa-3x text-muted mb-3"></i>
                  <p className="text-muted">{t('home.insurance.noInsurance')}</p>
                </div>
              ) : (
                <div className="insurance-swiper-container">
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }}
                    speed={800}
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    key={i18n.language}
                    breakpoints={{
                      320: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      480: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                      },
                      768: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                      },
                      1024: {
                        slidesPerView: 5,
                        spaceBetween: 35,
                      },
                      1200: {
                        slidesPerView: 6,
                        spaceBetween: 40,
                      },
                    }}
                    className="insurance-swiper"
                  >
                    {insurances.map((insurance) => (
                      <SwiperSlide key={insurance.id}>
                        <div className="insurance-logo-item">
                          <img
                            src={insurance.imageUrl}
                            alt={insurance.name || 'Insurance Company'}
                            className="img-fluid"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
